import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Row, Col, Image, Button, Spinner } from "react-bootstrap";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import config from "../config";
import axios from "axios";
import { toast } from "react-toastify";

function CollapsibleExample() {
  const navigate = useNavigate();

  const handleNavigate = (categoryName, seo_slug) => {
    navigate(`/${categoryName}/${seo_slug}`);
    window.location.reload();
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [isScrolled, setIsScrolled] = useState(false);

  const [loading, setLoading] = useState(true);
  const [coursedata, setCoursedata] = useState([]);
  const [coursecategory, setCoursecategory] = useState([]);
  const [error, setError] = useState(null);

  const [headerdiscount, setHeaderDiscount] = useState("");
  const [haederGrab, setHaederGrab] = useState("");

  // Special Offer All field
  const [isSubmittingOffer, setIsSubmittingOffer] = useState(false);
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");

  //  Validation errors
  const [errors, setErrors] = useState({});

  // All Validations
  const validate = () => {
    const newErrors = {};

    if (!fullname) {
      newErrors.fullname = "Full Name is required";
    } else if (fullname.trim().split(" ").length < 2) {
      newErrors.fullname = "Enter both first and last name";
    }

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }

    if (!phonenumber) {
      newErrors.phonenumber = "Mobile Number is required";
    }

    return newErrors;
  };

  const offer_submit = async () => {
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmittingOffer(true);
      let item = {};
      item.full_name = fullname;
      item.email = email;
      item.mobile_number = phonenumber;

      try {

        let response = await fetch(`${config.API_BASE_URL}/special_offer`, {
          method: "post",
          body: JSON.stringify(item),
          headers: {
            "Content-Type": "application/json",
          },
        });
        response = await response.json();
        if (response.status === 1) {


          // Zoho Lead API Code Start
          // Split the name into an array
          const nameParts = fullname.split(" ");

          // Extract the first name and last name
          const zoho_firstname = nameParts[0];
          const zoho_lastname = nameParts[1];

          const payload = {
            data: [
              {
                Company: "Agile",
                First_Name: zoho_firstname,
                Last_Name: zoho_lastname,
                Email: email,
                Phone: phonenumber,
                Lead_Status: "New",
                Lead_Source: "Direct",
                Page_URL: window.location.href
              },
            ],
            trigger: ["approval", "workflow", "blueprint"],
          };

          try {
            const response = await fetch(`${config.API_BASE_URL}/zoho/special_offer`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.status === 1) {
              setErrors({});

              // toast.success(result.message);
            } else {
              // toast.error(result.message);
              console.error("Zoho Error:", result);
            }
          } catch (error) {
            console.error("Fetch error:", error);
          }
          // Zoho Lead API Code End

          setErrors({});
          setFullname("");
          setEmail("");
          setPhonenumber("");
          setShow(false);

          // Display alert with message
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An unexpected error occurred.");
      } finally {
        setIsSubmittingOffer(false); // End the loading state
      }
    } else {
      setErrors(validationErrors);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 75) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Define your API URL
    const apiUrl = `${config.API_BASE_URL}/cat_course`;

    // Make the POST request using axios
    axios
      .post(apiUrl, {})
      .then((response) => {
        if (response.data.status === 1) {
          setCoursedata(response.data.data);
        } else {
          setError("Failed to load content");
          // console.error("Error:", response.data.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Axios Error:", error);
      });

    // Define your API URL
    const apiUrlHeader = `${config.API_BASE_URL}/header`;

    // Make the POST request using axios
    axios
      .post(apiUrlHeader, {})
      .then((response) => {
        if (response.data.status === 1) {
          setHeaderDiscount(response.data.data.discount_text);
          setHaederGrab(response.data.data.button_text);
        } else {
          setError("Failed to load content");
          // console.error("Error:", response.data.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Axios Error:", error);
      });

    // Define your API URL
    const apiUrlcategory = `${config.API_BASE_URL}/course_category`;

    // Make the POST request using axios
    axios
      .post(apiUrlcategory, {})
      .then((response) => {
        if (response.data.status === 1) {
          setCoursecategory(response.data.data);
        } else {
          setError("Failed to load content");
          // console.error("Error:", response.data.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Axios Error:", error);
      });

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [activeCategory, setActiveCategory] = useState("");

  useEffect(() => {
    // Only set the active category once the first matching category is found
    for (let i = 0; i < coursecategory.length; i++) {
      const Course_Category = coursecategory[i];
      const filteredCourses = coursedata.filter(
        (course) => Course_Category.name === course.category_name
      );

      // If a match is found, set the active category  and break the loop
      if (filteredCourses.length > 0) {
        setActiveCategory(Course_Category.name);
        break; // Stop the loop after finding the first match
      }
    }
  }, [coursecategory, coursedata]); // Depend on coursecategory and coursedata

  const [showMegaMenu, setShowMegaMenu] = useState(false);

  return (
    <>
      <section className="topbar">
        <Container>
          <Row>
            <Col md={4} sm={4} className="phone">
              <img
                src={`${config.BASE_URL}/assets/images/cnt-phone.svg`}
                className="img-fluid"
                alt="country"
              />
              <Link to="tel:919143964396">+91 91 4396 4396</Link>
            </Col>
            <Col md={4} sm={4} className="mail">
              <img
                src={`${config.BASE_URL}/assets/images/mail.png`}
                className="img-fluid"
                alt="mail"
              />
              <Link to="mailto:info@agileseeker.com">
                info@agileseekers.com
              </Link>
            </Col>
            <Col md={4} sm={4} className="social">
              <Link to="https://www.facebook.com/agileseekers" target="_blank">
                <img
                  src={`${config.BASE_URL}/assets/images/facebook.png`}
                  className="img-fluid"
                  alt="facebook"
                />
              </Link>
              <Link
                to="https://www.instagram.com/agileSeekers/"
                target="_blank"
              >
                <img
                  src={`${config.BASE_URL}/assets/images/instagram.png`}
                  className="img-fluid"
                  alt="instagram"
                />
              </Link>
              <Link
                to="https://www.linkedin.com/company/agileSeekers"
                target="_blank"
              >
                <img
                  src={`${config.BASE_URL}/assets/images/linkedin.png`}
                  className="img-fluid"
                  alt="linkedin"
                />
              </Link>
              <Link to="https://x.com/AgileSeekers" target="_blank">
                <img
                  src={`${config.BASE_URL}/assets/images/twitter.png`}
                  className="img-fluid"
                  alt="twitter"
                />
              </Link>
              <Link to="https://www.youtube.com/@agileSeekers" target="_blank">
                <img
                  src={`${config.BASE_URL}/assets/images/youtube.png`}
                  className="img-fluid"
                  alt="youtube"
                />
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="discountbar">
        <Container>
          <Row>
            <Col className="discountbox">
              <p>{headerdiscount}</p>
              <Link onClick={handleShow}>
                <p>{haederGrab}</p>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Laptop Screen View Menu */}
      {["lg"].map((expand) => (
        <Navbar
          key={expand}
          expand={expand}
          collapseOnSelect
          id="agnav"
          className={`bg-body-tertiary ${isScrolled ? "scrolled" : ""}`}
        >
          <Container>
            <Navbar.Brand href="/">
              <img
                src={`${config.BASE_URL}/assets/images/logo.svg`}
                className="img-fluid"
                alt="logo"
              />
            </Navbar.Brand>

            <Col
              className="acbtn mobhide"
              onMouseEnter={() => setShowMegaMenu(true)}
            >
              <NavLink>
                <Image
                  src={`${config.BASE_URL}/assets/images/acbar.png`}
                  className="img-fluid"
                  alt="acbar"
                />
                All Courses
                <Image
                  src={`${config.BASE_URL}/assets/images/navdrop.png`}
                  className="img-fluid"
                  alt="navdrop"
                />
              </NavLink>
            </Col>

            {showMegaMenu && (
              <Col
                className="acdrop mobhide"
                onMouseEnter={() => setShowMegaMenu(true)}
                onMouseLeave={() => setShowMegaMenu(false)}
              >
                <Row className="mx-0">
                  <Col md={4} className="accat">
                    {loading && <Col>Loading...</Col>}
                    {!loading && error && <Col>{error}</Col>}
                    {!loading &&
                      !error &&
                      coursecategory.map((Course_Category, index) => {
                        const filteredCourses = coursedata.filter(
                          (course) =>
                            Course_Category.name === course.category_name
                        );

                        return (
                          filteredCourses.length > 0 && (
                            <Link
                              to="/"
                              data-category={Course_Category.name}
                              onMouseEnter={() =>
                                setActiveCategory(Course_Category.name)
                              }
                            >
                              <span>{Course_Category.name}</span>
                              <Image
                                src={`${config.BASE_URL}/assets/images/navdrop.png`}
                                style={{
                                  visibility:
                                    activeCategory === Course_Category.name
                                      ? "visible"
                                      : "hidden",
                                }}
                                className="img-fluid"
                                alt="navdrop"
                              />
                            </Link>
                          )
                        );
                      })}
                  </Col>

                  <Col md={8} className="aclink">
                    {(() => {
                      const filteredCourses = coursedata.filter(
                        (course) => activeCategory === course.category_name
                      );

                      {
                        loading && <Link to="#">Loading...</Link>;
                      }

                      {
                        !loading && error && <Link to="#">{error}</Link>;
                      }

                      if (filteredCourses.length > 0) {
                        return (
                          <Col className="courses-content-1">
                            {filteredCourses.map((course, index) => (
                              <Link
                                onClick={() =>
                                  handleNavigate(
                                    course.category_seo_slug,
                                    course.seo_slug
                                  )
                                }
                                key={index}
                              >
                                {course.name}
                              </Link>
                            ))}
                          </Col>
                        );
                      }
                    })()}
                  </Col>
                </Row>
              </Col>
            )}

            {/* Mobile Screen View Menu */}

            {["lg"].map((ac) => (
              <Navbar
                key={ac}
                expand={ac}
                className="bg-body-tertiary me-auto ac-navbar deskhide"
              >
                <Container fluid>
                  <Navbar.Toggle aria-controls={`offcanvasNavbar-ac-${ac}`}>
                    <Image
                      src={`${config.BASE_URL}/assets/images/acbar.png`}
                      className="img-fluid"
                      alt="acbar"
                    />
                    All Courses
                    <Image
                      src={`${config.BASE_URL}/assets/images/navdrop.png`}
                      className="img-fluid"
                      alt="navdrop"
                    />
                  </Navbar.Toggle>
                  <Navbar.Offcanvas
                    id={`offcanvasNavbar-ac-${ac}`}
                    aria-labelledby={`offcanvasNavbarLabel-ac-${ac}`}
                    placement="start"
                  >
                    <Offcanvas.Header closeButton>
                      <img
                        src={`${config.BASE_URL}/assets/images/logo.svg`}
                        className="img-fluid"
                        alt="logo"
                      />
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Nav className="justify-content-end flex-grow-1">
                        <Accordion>
                          {coursecategory.map((Course_Category) => {
                            const filteredCourses = coursedata.filter(
                              (course) =>
                                Course_Category.name === course.category_name
                            );

                            return (
                              filteredCourses.length > 0 && (
                                <Accordion.Item
                                  eventKey={Course_Category.id}
                                  key={Course_Category.id}
                                >
                                  <Accordion.Header>
                                    <img
                                      src={`${config.BASE_URL}/assets/images/topic3.png`}
                                      className="img-fluid"
                                      alt="category"
                                    />
                                    {Course_Category.name}
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <Col>
                                      {loading ? (
                                        <NavLink>Loading...</NavLink>
                                      ) : error ? (
                                        <NavLink>{error}</NavLink>
                                      ) : (
                                        filteredCourses.map((course, index) => (
                                          <NavLink
                                            //  as="div"
                                            onClick={() =>
                                              handleNavigate(
                                                course.category_seo_slug,
                                                course.seo_slug
                                              )
                                            }
                                            key={index}
                                          >
                                            {course.name}
                                          </NavLink>
                                        ))
                                      )}
                                    </Col>
                                  </Accordion.Body>
                                </Accordion.Item>
                              )
                            );
                          })}
                        </Accordion>
                      </Nav>
                    </Offcanvas.Body>
                  </Navbar.Offcanvas>
                </Container>
              </Navbar>
            ))}

            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="start"
            >
              <Offcanvas.Header closeButton>
                <img
                  src={`${config.BASE_URL}/assets/images/logo.svg`}
                  className="img-fluid"
                  alt="logo"
                />
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="ms-auto">
                  <Nav.Link href="/">Home</Nav.Link>
                  <Nav.Link href="/corporate">Corporate</Nav.Link>
                  <Nav.Link href="/resources">Resources</Nav.Link>
                  <Nav.Link href="/blogs">Blogs</Nav.Link>
                  <Nav.Link href="/contact-us">Contact Us</Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}

      {/* Special Offer Modal */}
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        centered
        className="disc-modal"
        backdrop="static"
      >
        <Modal.Body>
          <Row className="mx-0">
            <Col md={6} className="di-mod-left">
              <Image
                src={`${config.BASE_URL}/assets/images/special-offer.png`}
                className="img-fluid spof"
                alt="special-offer"
              />
              <Image
                src={`${config.BASE_URL}/assets/images/super-offer.png`}
                className="img-fluid"
                alt="super-offer"
              />
            </Col>

            <Col md={6} className="di-mod-right">
              <Link onClick={handleClose}>
                <Image
                  src={`${config.BASE_URL}/assets/images/close.png`}
                  className="img-fluid"
                  alt="close"
                />
              </Link>

              <Form>
                <Form.Group className="mb-3" controlId="formGridPassword">
                  <Form.Label>Please fill in the details below</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Full Name"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                  />

                  {/* Full name validation */}
                  {errors.fullname && (
                    <div className="text-danger">{errors.fullname}</div>
                  )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="formGridAddress1">
                  <Form.Control
                    type="email"
                    placeholder="Enter Your Email Id"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  {/* Email validation */}
                  {errors.email && (
                    <div className="text-danger">{errors.email}</div>
                  )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="formGridAddress2">
                  <Form.Control
                    type="text"
                    placeholder="Mobile Number"
                    value={phonenumber}
                    onChange={(e) => setPhonenumber(e.target.value)}
                  />

                  {/* Phone Number validation */}
                  {errors.phonenumber && (
                    <div className="text-danger">{errors.phonenumber}</div>
                  )}
                </Form.Group>

                {/* <Button variant="primary" type="button" onClick={offer_submit}>
                  Claim Offer
                </Button> */}
                <Button
                  variant="primary"
                  type="button"
                  onClick={offer_submit}
                  disabled={isSubmittingOffer}
                >
                  {isSubmittingOffer ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="mx-2"
                      />
                      Loading...
                    </>
                  ) : (
                    "Claim Offer"
                  )}
                </Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CollapsibleExample;
